import t from "react";
const o = t.createContext(void 0), n = () => t.useContext(o);
export {
  o as AccordionVariantContext,
  n as useAccordionVariant
};
